module.exports = __webpack_public_path__ + "static/img/coverImage3.dab38f83.jpg";